/* eslint-disable */

export function createObjectURL(object) {
  return URL.createObjectURL(object);
}
